/**
 All of the routes for the Material Dashboard 2 React are added here,
 You can add a new route, customize the routes and delete the routes here.

 Once you add a new route on this file it will be visible automatically on
 the Sidenav.

 For adding a new route you can follow the existing routes in the routes array.
 1. The `type` key with the `collapse` value is used for a route.
 2. The `type` key with the `title` value is used for a title inside the Sidenav.
 3. The `type` key with the `divider` value is used for a divider between Sidenav items.
 4. The `name` key is used for the name of the route on the Sidenav.
 5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
 6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
 7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
 inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
 8. The `route` key is used to store the route location which is used for the react router.
 9. The `href` key is used to store the external links location.
 10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
 10. The `component` key is used to store the component of its route.
 */

// Screen modules load when their route renders. The login page must not
// download ag-grid, spreadsheets, or PDF tooling used by those screens.
import { lazy } from "react";
import Icon from "@mui/material/Icon";

const Brands = lazy(() => import("layouts/brands"));
const Events = lazy(() => import("layouts/events"));
const Stores = lazy(() => import("layouts/stores"));
const Product = lazy(() => import("layouts/product"));
const NewProduct = lazy(() => import("layouts/new-product"));
const ProductCategories = lazy(() => import("layouts/product-category"));
const MasterAttribute = lazy(() => import("layouts/master-attribute"));
const Customer = lazy(() => import("layouts/cutsomer"));
const Order = lazy(() => import("layouts/order"));
const Promotion = lazy(() => import("layouts/promotion"));
const Advertisment = lazy(() => import("layouts/advertisement"));
const DeviceMaster = lazy(() => import("layouts/device-Master"));
const FixtureMaster = lazy(() => import("layouts/fixture-Master"));
const Reports = lazy(() => import("layouts/reports"));
const InformationGuide = lazy(() => import("layouts/information-guide"));
const SampleFeedback = lazy(() => import("layouts/sample-feedback"));
const SisSales = lazy(() => import("layouts/sis-sales"));
const TermsheetMaster = lazy(() => import("layouts/termsheet-master"));
const BcLogs = lazy(() => import("layouts/bc-logs"));
const RfidLogs = lazy(() => import("layouts/rfid-logs"));
const ProductDetail = lazy(() => import("layouts/product/forms/productDetail"));
const UserRoleManagement = lazy(() => import("layouts/user-role-management"));

let adminRoutes = [
  {
    type: "collapse",
    name: "Brands",
    key: "dashboard",
    icon: <Icon fontSize="small">star</Icon>,
    route: "/dashboard",
    component: <Brands />,
  },
  {
    type: "collapse",
    name: "Information Guides",
    key: "information-guide",
    icon: <Icon fontSize="small">book</Icon>,
    route: "/information-guide",
    component: <InformationGuide />,
  },
  {
    type: "collapse",
    name: "Stores",
    key: "stores",
    icon: <Icon fontSize="small">store_front</Icon>,
    route: "/stores",
    component: <Stores />,
  },
  {
    type: "collapse",
    name: "Events",
    key: "events",
    icon: <Icon fontSize="small">confirmation_number</Icon>,
    route: "/events",
    component: <Events />,
  },
  {
    type: "collapse",
    name: "Device Master",
    key: "device-master",
    icon: <Icon fontSize="small">monitor</Icon>,
    route: "/device-master",
    component: <DeviceMaster />,
  },
  {
    type: "collapse",
    name: "Fixture Master",
    key: "fixture-master",
    icon: <Icon fontSize="small">monitor</Icon>,
    route: "/fixture-master",
    component: <FixtureMaster />,
  },
  {
    type: "collapse",
    name: "Store Digital Content",
    key: "advertisment",
    icon: <Icon fontSize="small">ondemand_video</Icon>,
    route: "/advertisment",
    component: <Advertisment />,
  },
  {
    type: "collapse",
    name: "Product",
    key: "product",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/product",
    component: <Product />,
  },
  {
    type: "hidden",
    name: "Product Detail",
    key: "product-detail",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/product/product-detail",
    component: <ProductDetail />,
  },
  {
    type: "collapse",
    name: "Product Category",
    key: "product-category",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/product-category",
    component: <ProductCategories />,
  },
  {
    type: "collapse",
    name: "Master Attribute",
    key: "master-attribute",
    icon: <Icon fontSize="small">summarize</Icon>,
    route: "/master-attribute",
    component: <MasterAttribute />,
  },
  {
    type: "collapse",
    name: "Customer",
    key: "customer",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/customer",
    component: <Customer />,
  },
  {
    type: "collapse",
    name: "Orders",
    key: "orders",
    icon: <Icon fontSize="small">shopping_cart</Icon>,
    route: "/orders",
    component: <Order />,
  },
  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    icon: <Icon fontSize="small">analytics</Icon>,
    route: "/reports",
    component: <Reports />,
  },
  {
    type: "collapse",
    name: "Sample Feedback",
    key: "sample-feedback",
    icon: <Icon fontSize="small">reviews</Icon>,
    route: "/sample-feedback",
    component: <SampleFeedback />,
  },
  {
    type: "collapse",
    name: "Promotion",
    key: "promotion",
    icon: <Icon fontSize="small">percent</Icon>,
    route: "/promotion",
    component: <Promotion />,
  },
  {
    type: "collapse",
    name: "SIS Sales",
    key: "sis-sales",
    icon: <Icon fontSize="small">edit_note</Icon>,
    route: "/sis-sales",
    component: <SisSales />,
  },
  {
    type: "collapse",
    name: "BC Logs",
    key: "bc-logs",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/bc-logs",
    component: <BcLogs />,
  },
  {
    type: "collapse",
    name: "RFID Logs",
    key: "rfid-logs",
    icon: <Icon fontSize="small">nfc</Icon>,
    route: "/rfid-logs",
    component: <RfidLogs />,
  },
  // {
  //   type: "collapse",
  //   name: "Loyalty",
  //   key: "loyalty",
  //   icon: <Icon fontSize="small">emoji_events</Icon>,
  //   route: "/loyalty",
  //   component: <Loyalty />,
  // },
  // {
  //   type: "collapse",
  //   name: "QR-Code",
  //   key: "qr-code",
  //   icon: <Icon fontSize="small">qr_code_scanner</Icon>,
  //   route: "/qr-code",
  //   component: <QRCode />,
  // },

  // {
  //   type: "collapse",
  //   name: "Master Activity",
  //   key: "master-activity",
  //   icon: <Icon fontSize="small">folder_special</Icon>,
  //   route: "/master-activity",
  //   component: <MasterActivity />,
  // },
  // {
  //   type: "collapse",
  //   name: "Activity",
  //   key: "activity",
  //   icon: <Icon fontSize="small">star</Icon>,
  //   route: "/activity",
  //   component: <Activity/>,
  // },
  // {
  //   type: "collapse",
  //   name: "Channel",
  //   key: "channel",
  //   icon: <Icon fontSize="small">account_tree</Icon>,
  //   route: "/channel",
  //   component: <Channel />,
  // },
  // {
  //   type: "collapse",
  //   name: "E-Commerce Media",
  //   key: "ecommerce-media",
  //   icon: <Icon fontSize="small">video_camera_back</Icon>,
  //   route: "/ecommerce-media",
  //   component: <ECommerceMedia/>,
  // },
  // {
  //   type: "collapse",
  //   name: "E-Commerce Section",
  //   key: "ecommerce-section",
  //   icon: <Icon fontSize="small"><ListIcon /></Icon>,
  //   route: "/ecommerce-section",
  //   component: <EcommerceSection/>,
  // },
  // {
  //   type: "collapse",
  //   name: "E-Commerce Comopoent",
  //   key: "ecommerce-component",
  //   icon: <Icon fontSize="small"><ListIcon /></Icon>,
  //   route: "/ecommerce-component",
  //   component: <EcommerceComponent />,
  // },
  // {
  //   type: "collapse",
  //   name: "Categories",
  //   key: "categories",
  //   icon: <GridViewRoundedIcon fontSize="small" />,
  //   route: "/categories",
  //   component: <Categories />,
  // },
  // {
  //   type: "collapse",
  //   name: "News",
  //   key: "news",
  //   icon: <Icon fontSize="small">newspaper</Icon>,
  //   route: "/news",
  //   component: <News />,
  // },
  // {
  //   type: "collapse",
  //   name: "Theme",
  //   key: "theme",
  //   icon: <Icon fontSize="small">color_lense</Icon>,
  //   route: "/theme",
  //   component: <Theme />,
  // },
  // {
  //   type: "collapse",
  //   name: "Communication",
  //   key: "communication",
  //   icon: <Icon fontSize="small">chat</Icon>,
  //   route: "/communication",
  //   component: <Dashboard />,
  // },
  // {
  //   type: "collapse",
  //   name: "Accounting",
  //   key: "accounting",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/accounting",
  //   component: <Dashboard />,
  // },
];

let routes = [
  {
    type: "collapse",
    name: "Brands",
    key: "dashboard",
    icon: <Icon fontSize="small">star</Icon>,
    route: "/dashboard",
    component: <Brands />,
  },
  {
    type: "collapse",
    name: "Information Guides",
    key: "information-guide",
    icon: <Icon fontSize="small">book</Icon>,
    route: "/information-guide",
    component: <InformationGuide />,
  },
  {
    type: "collapse",
    name: "Product",
    key: "product",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/product",
    component: <Product />,
  },
  {
    type: "hidden",
    name: "Product Detail",
    key: "product-detail",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/product/product-detail",
    component: <ProductDetail />,
  },
  {
    type: "collapse",
    name: "Store Digital Content",
    key: "advertisment",
    icon: <Icon fontSize="small">ondemand_video</Icon>,
    route: "/advertisment",
    component: <Advertisment />,
  },
  {
    type: "collapse",
    name: "Promotion",
    key: "promotion",
    icon: <Icon fontSize="small">percent</Icon>,
    route: "/promotion",
    component: <Promotion />,
  },

  // {
  //   type: "collapse",
  //   name: "Events",
  //   key: "events",
  //   icon: <Icon fontSize="small">confirmation_number</Icon>,
  //   route: "/events",
  //   component: <Events />,
  // },
  // {
  //   type: "collapse",
  //   name: "Store Digital Content",
  //   key: "advertisment",
  //   icon: <Icon fontSize="small">ondemand_video</Icon>,
  //   route: "/advertisment",
  //   component: <Advertisment/>,
  // },
];

let broadwayRm = [
  {
    type: "collapse",
    name: "Brands",
    key: "dashboard",
    icon: <Icon fontSize="small">star</Icon>,
    route: "/dashboard",
    component: <Brands />,
  },
  {
    type: "collapse",
    name: "Information Guides",
    key: "information-guide",
    icon: <Icon fontSize="small">book</Icon>,
    route: "/information-guide",
    component: <InformationGuide />,
  },
  {
    type: "collapse",
    name: "Product",
    key: "product",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/product",
    component: <Product />,
  },
  {
    type: "hidden",
    name: "Product Detail",
    key: "product-detail",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/product/product-detail",
    component: <ProductDetail />,
  },
  {
    type: "collapse",
    name: "Events",
    key: "events",
    icon: <Icon fontSize="small">confirmation_number</Icon>,
    route: "/events",
    component: <Events />,
  },
  {
    type: "collapse",
    name: "Store Digital Content",
    key: "advertisment",
    icon: <Icon fontSize="small">ondemand_video</Icon>,
    route: "/advertisment",
    component: <Advertisment />,
  },
  {
    type: "collapse",
    name: "Orders",
    key: "orders",
    icon: <Icon fontSize="small">shopping_cart</Icon>,
    route: "/orders",
    component: <Order />,
  },
  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    icon: <Icon fontSize="small">analytics</Icon>,
    route: "/reports",
    component: <Reports />,
  },
  {
    type: "collapse",
    name: "Sample Feedback",
    key: "sample-feedback",
    icon: <Icon fontSize="small">reviews</Icon>,
    route: "/sample-feedback",
    component: <SampleFeedback />,
  },
  {
    type: "collapse",
    name: "Promotion",
    key: "promotion",
    icon: <Icon fontSize="small">percent</Icon>,
    route: "/promotion",
    component: <Promotion />,
  },
  {
    type: "collapse",
    name: "SIS Sales",
    key: "sis-sales",
    icon: <Icon fontSize="small">edit_note</Icon>,
    route: "/sis-sales",
    component: <SisSales />,
  },
];

let storeTeam = [
  {
    type: "collapse",
    name: "SIS Sales",
    key: "sis-sales",
    icon: <Icon fontSize="small">edit_note</Icon>,
    route: "/sis-sales",
    component: <SisSales />,
  },
  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    icon: <Icon fontSize="small">analytics</Icon>,
    route: "/reports",
    component: <Reports />,
  },
];

let sisVendor = [
  {
    type: "collapse",
    name: "Brands",
    key: "dashboard",
    icon: <Icon fontSize="small">star</Icon>,
    route: "/dashboard",
    component: <Brands />,
  },
  {
    type: "collapse",
    name: "Information Guides",
    key: "information-guide",
    icon: <Icon fontSize="small">book</Icon>,
    route: "/information-guide",
    component: <InformationGuide />,
  },
  {
    type: "collapse",
    name: "SIS Sales",
    key: "sis-sales",
    icon: <Icon fontSize="small">edit_note</Icon>,
    route: "/sis-sales",
    component: <SisSales />,
  },
];

const termsheetRoute = {
  type: "collapse",
  name: "Termsheet Master",
  key: "termsheet-master",
  icon: <Icon fontSize="small">star</Icon>,
  route: "/termsheet-master",
  component: <TermsheetMaster />,
};

const userRoleManagementRoute = {
  type: "collapse",
  name: "User Role Management",
  key: "user-role-management",
  icon: <Icon fontSize="small">admin_panel_settings</Icon>,
  route: "/user-role-management",
  component: <UserRoleManagement />,
};

const newProductRoute = {
  type: "collapse",
  name: "New Product",
  key: "new-product",
  icon: <Icon fontSize="small">add_box</Icon>,
  route: "/new-product",
  component: <NewProduct />,
};

export {
  adminRoutes,
  routes,
  broadwayRm,
  storeTeam,
  sisVendor,
  termsheetRoute,
  userRoleManagementRoute,
  newProductRoute,
};
